import { Button, Group, Modal, Text } from "@mantine/core";
import { ISpecificationTable } from "@mctypes/frontend.types";
import { AgGridReact } from "ag-grid-react";
import React, { useState } from "react";
import { VSpace } from "../index";
import ExcelImportValidator, { ValidatorProps, ValidatorRef } from "./ExcelImportValidator";

export const ExcelImportValidatorWithSpecTable: React.FC<
  {
    specificationTable?: ISpecificationTable;
    closeAfterSuccessfulImport?: boolean;
  } & ValidatorProps
> = ({ specificationTable, onValidated, closeAfterSuccessfulImport, ...props }) => {
  const [specificationModalOpen, setSpecificationModalOpen] = useState<boolean>(false);
  const [errors, setErrors] = useState<string[]>(null);

  return (
    <div>
      <Button color="blue" onClick={() => setSpecificationModalOpen(true)}>
        Importer excel-fil
      </Button>

      {specificationTable && specificationModalOpen && (
        <SpecificationModal
          specificationTable={specificationTable}
          isOpened={specificationModalOpen}
          close={() => setSpecificationModalOpen(false)}
          onValidated={(result) => {
            if (result.errors) {
              setErrors(result.errors);
            } else {
              onValidated(result);
              if (closeAfterSuccessfulImport) {
                setSpecificationModalOpen(false);
              }
            }
          }}
          {...props}
        />
      )}

      {errors?.length > 0 && (
        <Modal opened={errors.length > 0} onClose={() => setErrors(null)} title="Feil i Excel-fil" size="lg" centered>
          <ul>
            {errors.map((error, i) => (
              <li key={i}>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                    fontFamily: "inherit",
                  }}
                >
                  {error}
                </pre>
              </li>
            ))}
          </ul>
          <Group mt="md">
            <Button color="blue" onClick={() => setErrors(null)}>
              Lukk
            </Button>
          </Group>
        </Modal>
      )}
    </div>
  );
};

export default ExcelImportValidatorWithSpecTable;

const SpecificationModal: React.FC<
  {
    specificationTable: ISpecificationTable;
    close: () => void;
    isOpened?: boolean;
  } & ValidatorProps
> = ({ specificationTable, close, isOpened, ...props }) => {
  const validatorRef = React.useRef<ValidatorRef>(null);

  return (
    <Modal opened={isOpened} onClose={close} title="Spesifikasjon" size="lg" centered>
      <Text mb="xs">Excel-filen skal inneholde disse kolonnene</Text>
      {specificationTable.description && <Text mb="sm">{specificationTable.description}</Text>}

      <div className="ag-theme-alpine" style={{ height: 300, width: "100%" }}>
        <AgGridReact
          defaultColDef={{
            resizable: true,
            sortable: false,
            suppressHeaderMenuButton: true,
            suppressMovable: true,
          }}
          suppressMovableColumns
          suppressMenuHide
          onGridReady={(params) => params.api.autoSizeAllColumns()}
          rowData={specificationTable.data}
          columnDefs={specificationTable.columns}
          domLayout="autoHeight"
        />
      </div>

      <VSpace />

      <ExcelImportValidator ref={validatorRef} {...props}>
        <Group>
          <Button onClick={() => validatorRef.current.selectFile()} color="blue">
            Velg fil
          </Button>
        </Group>
      </ExcelImportValidator>
    </Modal>
  );
};
